<template>
  <div class="main-footer">
    <div class="container">
      <div class="row visible-lg-block">
        <div class="left">
          <ul class="company">
            <li>
              <img src="@/assets/img/logo02.png" alt="" class="logo" />
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="col-xs-6 col-sm-6">
            <ul class="classify">
              <li class="col-xs-4 col-sm-4"></li>
              <li class="col-xs-6 col-sm-6">
                <h3>Product</h3>
                <div class="line"></div>
                <p>
                  <router-link to="/products">FAW TRACTOR Truck</router-link>
                </p>
                <p><router-link to="/products">FAW DUMP Truck</router-link></p>
                <p><router-link to="/products">FAW CARGO Truck</router-link></p>
                <p>
                  <router-link to="/products">FAW SPECIAL Truck</router-link>
                </p>
                <p><router-link to="/products">FAW LIGHT Truck</router-link></p>
              </li>
            </ul>
          </div>
          <div class="col-xs-6 col-sm-6">
            <ul class="row classify">
              <li class="col-xs-6 col-sm-6">
                <h3>Services</h3>
                <div class="line"></div>
                <p><router-link to="/service">Within warranty</router-link></p>
                <p><router-link to="/service">Product Features</router-link></p>
              </li>
              <li class="col-xs-6 col-sm-6">
                <h3>contact us</h3>
                <div class="line"></div>
                <p>
                  <img
                    src="@/assets/img/icon01.png"
                    alt="email"
                    title="email"
                  /><span>info@fawcamionmexico.com</span>
                </p>
                <p>
                  <img
                    src="@/assets/img/icon04.png"
                    alt="mobile phone"
                    title="mobile phone"
                  /><span>5955961886</span>
                </p>
                <p>
                  <img
                    src="@/assets/img/icon03.png"
                    alt="WhatsApp"
                    title="WhatsApp"
                  /><span>5951226144</span>
                </p>
              </li>
            </ul>
            <div class="row message-icon">
              <div class="message-item">
                <div class="icon">
                  <img src="@/assets/img/icon11.png" alt="" /><span
                    >Whatsapp</span
                  >
                  <div class="icon-hover">
                    <img src="@/assets/img/QRcode.png" alt="" />
                    <div class="increase"></div>
                  </div>
                </div>
              </div>
              <div class="message-item">
                <div class="icon">
                  <img src="@/assets/img/icon12.png" alt="" /><span>Facebook</span>
                  <div class="icon-hover">
                    <img src="@/assets/img/QRcode02.png" alt="" />
                    <div class="Facebook"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row copyright">
        <p>
          Copyright © Truck Services {{ new Date().getFullYear() }}. All rights
          reserved.
        </p>
        <!-- <p>
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >{SITE_ICP}</a
          >
        </p> -->
      </div>
    </div>
    <div class="scroll-to-top" @click="toTop">
      <i class="el-icon-upload2"></i>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toTop() {
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style scoped lang="scss">
.main-footer {
  background-color: #000000;
  min-width: fit-content;
  color: #fff;

  a {
    color: #cccccc;

    &:hover {
      color: #fff;
    }
  }

  .scroll-to-top {
    position: fixed;
    cursor: pointer;
    right: 10px;
    bottom: 10px;
    width: 45px;
    height: 45px;
    line-height: 55px;
    background-color: #f4f6fa;
    border: 1px solid #cccccc;
    text-align: center;

    i {
      font-size: 28px;
      color: $main-color;
    }
  }

  .left {
    width: 25%;
    float: left;

    .company {
      background-color: rgba($color: #fff, $alpha: 0.23);
      padding: 100px 20px;
      text-align: center;
      border-radius: 0px 0px 8px 8px;

      li {
        // &:first-child {
        //   padding: 0 0 20px;
        //   margin: 0 0 20px;
        //   border-bottom: 1px solid #FFF;
        // }

        .logo {
          margin: 0 0 10px;
					max-width: 100%;
        }
      }
    }
  }

  .right {
    margin: 0 0 30px 0;
    width: 75%;
    float: left;

    .message-icon {
      background: #1d1d1d;
      border-radius: 4px 4px 4px 4px;
      padding: 30px;

      .message-item {
        width: 50%;
        float: left;
        text-align: center;

        .icon {
          cursor: pointer;
          position: relative;
          width: fit-content;
          margin: 0 auto;

          &:hover {
            .icon-hover {
              display: block;
            }
          }

          img {
            margin: 0 5px 0 0;
          }

          .icon-hover {
            display: none;
            position: absolute;
            left: -80px;
            top: -22px;
            border: 1px solid #cccccc;
            background-color: #fff;

            img {
              width: 64px;
              margin: 0px;
            }

            .increase {
              position: absolute;
              top: 28px;
              right: -12px;
              width: 0;
              height: 0;
              border-width: 5px;
              border-color: transparent transparent transparent #cccccc;
              border-style: solid;
            }
          }
        }
      }
    }

    .classify {
      li {
        h3 {
          margin: 50px 0 20px 0;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
        }

        .line {
          width: 32px;
          height: 4px;
          background: #ffffff;
          margin: 0 0 20px 0;
        }

        p {
          color: #ccc;

          a {
            color: #ccc;
          }
        }

        img {
          margin: 0 5px 0 0;
        }
      }
    }
  }

  .copyright {
    padding: 20px 0;
    color: #cccccc;
    border-top: 1px solid #777777;
    text-align: center;
  }
}
</style>